export const TROUSER_DISPLAY_OPTIONS = {
  measurements: true,
  points: true,
  seamWalk: false,
};
